import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from './UpdateStatusDialog';
import {
  AdminStatusDescription,
  AdminStatusSwitchIcon,
} from './AdminStatusDialogContent';

// ============================================================================
// Helper: build props for admin activate/deactivate use case
// ============================================================================

export type AdminStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getAdminStatusDialogConfig(
  userName: string,
  isActive: boolean
): AdminStatusDialogConfig {
  const isActivating = !isActive;
  return {
    title: isActivating
      ? 'Aktywować administratora?'
      : 'Dezaktywować administratora?',
    content: (
      <AdminStatusDescription userName={userName} isActivating={isActivating} />
    ),
    confirmButtonLabel: isActivating ? 'Aktywuj' : 'Dezaktywuj',
    confirmButtonLabelLoading: isActivating
      ? 'Aktywowanie…'
      : 'Dezaktywowanie…',
    icon: <AdminStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
